import * as React from "react";
import { Icon } from "@grandvisionhq/icons";
/* empty css                  */
const ErrorMessage = ({ error, id, errorMessage }) => {
  return error && !!errorMessage ? /* @__PURE__ */ React.createElement("div", { id, className: "error-message__error" }, /* @__PURE__ */ React.createElement(
    Icon,
    {
      className: "error-message__icon",
      key: "alert-circle",
      name: "alert-circle",
      height: 16,
      width: 16
    }
  ), errorMessage) : null;
};
const ErrorMessage$1 = React.memo(ErrorMessage);
export {
  ErrorMessage$1 as default
};
//# sourceMappingURL=ErrorMessage.js.map
